import { InjectionToken } from '@angular/core';

export const urlConstants = {
  API_BASE_URL: '/api/v1',
  API_BASE_URL_V2: '/api/v2',
};

export type URLConstants = typeof urlConstants;

export const urlConstantsToken = new InjectionToken<URLConstants>(
  'urlConstantsToken'
);

export default urlConstants;
